export enum NotificationFilter {
  All = 'all',
  Unread = 'unread',
}
